module.exports = __webpack_public_path__ + "img/foyer-and-entryway.a99c28c.jpg";